import React, { Fragment } from 'react';
import DOMPurify from 'dompurify';
import { useTheme } from 'ThemeContext';
import processString from 'react-process-string';
import parser, { Tag } from 'bbcode-to-react';
import htmlParser from 'react-html-parser';

import { Wrapper, Content } from './ArticleDetails.style';

import { CustomArticleGallery } from 'components/ArticleGallery/ArticleGallery';

class CustomGalleryTag extends Tag {
  toReact() {
    const attributes = {
      id: this.params.id || this.getContent(true),
      title: this.params.title || '',
    };
    return <CustomArticleGallery {...attributes} />;
  }
}

parser.registerTag('customgallery', CustomGalleryTag);
parser.registerTag('gallery', CustomGalleryTag);
parser.registerTag('galeria', CustomGalleryTag);

function ArticleDetails({ data = '' }) {
  const theme = useTheme();
  let config = [
    {
      regex: /\[customgallery([\s\S]*?)\]([\s\S]*?)\[\/customgallery\]/g,
      fn: (key, result) => parser.toReact(result[0]),
    },
    {
      regex: /\[gallery([\s\S]*?)\]([\s\S]*?)\[\/gallery\]/g,
      fn: (key, result) => parser.toReact(result[0]),
    },
    {
      regex: /\[galeria([\s\S]*?)\]([\s\S]*?)\[\/galeria\]/g,
      fn: (key, result) => parser.toReact(result[0]),
    },
  ];
  return (
    <Wrapper>
      <Content theme={theme.CMS}>
        {processString(config)(
          DOMPurify.sanitize(data, {
            USE_PROFILES: { html: true },
            ADD_TAGS: ['iframe'],
            ADD_ATTR: [
              'allow',
              'allowfullscreen',
              'frameborder',
              'scrolling',
              'target',
            ],
          })
        )
          .flat(3)
          .map((string, key) => (
            <Fragment key={key}>
              {typeof string === 'string' || string instanceof String
                ? htmlParser(string)
                : string}
            </Fragment>
          ))}
      </Content>
    </Wrapper>
  );
}

export default ArticleDetails;
